import React from "react";
import DialogContent from "@mui/material/DialogContent";

export default function HeaderDialog(props) {
  return (
    <DialogContent
      className={props.className}
      style={{ backgroundColor: "#eee", paddingTop: 20 }}
    >
      {props.children}
    </DialogContent>
  );
}
